var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("menu-obchod", {
        attrs: { kravicka: _vm.kravicka, sideMenu: _vm.sideMenu },
        on: { hideSideMenu: _vm.hideSideMenu }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn --primary d-xl-none",
          staticStyle: { "z-index": "61" },
          attrs: { id: "openShopMenu" },
          on: {
            click: function($event) {
              _vm.sideMenu = !_vm.sideMenu
            }
          }
        },
        [_c("span", { staticClass: "icon" })]
      ),
      _vm._v(" "),
      _c("main", { staticClass: "shopMain --lightBg" }, [
        _c(
          "div",
          { staticClass: "shopHeader --whiteBg d-flex" },
          [
            _c("h2", { staticClass: "mb-0" }, [_vm._v("Zmenáreň")]),
            _vm._v(" "),
            _c("header-obchod", {
              attrs: { profil: _vm.profil },
              on: { updateProfil: _vm.emitUpdateProfil }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.responseText != ""
          ? _c(
              "div",
              {
                class:
                  "alert alert-dismissible fade show --shopAlert alert-" +
                  _vm.responseType,
                attrs: { role: "alert" }
              },
              [
                _c("p", { staticClass: "mb-0" }, [
                  _c("span", { class: "icon --" + _vm.responseType }),
                  _vm._v(_vm._s(_vm.responseText) + "\n            ")
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "alert",
                      "aria-label": "Close"
                    },
                    on: {
                      click: function($event) {
                        _vm.responseText = ""
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "o-zmenarenMain" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-12 col-lg-12 col-xl-6 position-normal"
              },
              [
                _c("h3", [_vm._v("Zameniť EAN kódy za dukáty")]),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v(
                      "Za každý správne pridaný EAN kód ti bude pripísaných\n                        "
                    ),
                    !_vm.profil.pouzivatel_id.pouzivatel_group
                      ? [_vm._v("5 dukátov")]
                      : [_vm._v("1 dukát")],
                    _vm._v(". Za "),
                    _c("br"),
                    _vm._v(
                      "\n                        dukáty môžeš nakupovať kravičke rôzne veci a robiť ju tak šťastnou."
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "zmenarenForm",
                    on: { submit: _vm.formSubmit }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          { attrs: { for: "ean_kod" } },
                          [
                            _vm._v(
                              "EAN kód mliečneho výrobku \n                                "
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "float-right mr-4",
                                attrs: { id: "popoverEan" }
                              },
                              [_vm._v("Kde nájdem EAN kód?")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                attrs: {
                                  target: "popoverEan",
                                  triggers: "click",
                                  placement: "top"
                                }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v("Kde ho nájdem?")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-center" }, [
                                  _c("p", [
                                    _vm._v(
                                      "Kódy EAN sa používajú na označovanie tovaru. Nájsť ich môžeš na obaloch produktov."
                                    )
                                  ]),
                                  _c("p", [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "https://www.adoptujkravicku.sk/hra/dist/images/content/ean-kod.jpg"
                                      }
                                    })
                                  ])
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("popover", { attrs: { name: "zmenaren" } }, [
                          _c("div", { staticClass: "text-center" }, [
                            _c("p", [
                              _vm._v(
                                "Kódy EAN sa používajú na označovanie tovaru."
                              ),
                              _c("br"),
                              _vm._v(" Nájsť ich môžeš na obaloch produktov.")
                            ]),
                            _c("p", [
                              _c("img", {
                                attrs: {
                                  src:
                                    "https://www.adoptujkravicku.sk/hra/dist/images/content/ean-kod.jpg"
                                }
                              })
                            ])
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ean_code,
                            expression: "ean_code"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.ean_code },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.ean_code = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm._m(0)
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(1)
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn --primary", attrs: { type: "submit" } },
      [_c("span", { staticClass: "icon" }), _vm._v("Zameniť ean kód")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-12 col-lg-12 col-xl-6" }, [
      _c("div", { staticClass: "o-applicationBanner" }, [
        _c("div", { staticClass: "m-applicationBanner__content" }, [
          _c("div", { staticClass: "a-applicationBanner__title" }, [
            _c("h3", [
              _vm._v("Skenujte EAN kódy pomocou novej mobilnej aplikácie pre "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://apps.apple.com/cz/app/adoptuj-kravi%C4%8Dku-skener/id1432428434"
                  }
                },
                [_vm._v("iOS")]
              ),
              _vm._v(" a "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://play.google.com/store/apps/details?id=sk.smr.adoptujkravicku"
                  }
                },
                [_vm._v("Android")]
              ),
              _vm._v(".")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "a-applicationBanner__btns" }, [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://apps.apple.com/cz/app/adoptuj-kravi%C4%8Dku-skener/id1432428434"
                }
              },
              [
                _c("img", {
                  staticClass: "img-fluid mr-md-2 mr-0 mb-1 mb-md-0",
                  attrs: { src: "assets/img/applestore.png", alt: "" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://play.google.com/store/apps/details?id=sk.smr.adoptujkravicku"
                }
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: "assets/img/gplay.png", alt: "" }
                })
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "m-applicationBanner__image" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              src: "assets/img/imgAppScreen.png",
              alt: "Mockup aplikácie"
            }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }